import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate, Link  } from 'react-router-dom';
import { useForm } from "react-hook-form";

import { login, GetUserRole } from "./../../reducers/actions/auth";

const Login = (showSideBar) => {
  let navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  
  
  showSideBar = false;
  
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  
  const { isLoggedIn } = useSelector((state) => state.auth);

  const dispatch = useDispatch();

  const onChangeEmail = (e) => {
    const email = e.target.value;
    setEmail(email);
  };

  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };

  const onSubmit = (e) => {
    setLoading(true);
    dispatch(login(email, password))
      .then(() => {
        dispatch(GetUserRole()).then(() => {
          navigate("/instructive");
        });
      })
      .catch(() => {
        setLoading(false);
      });
  };
  if (isLoggedIn) {
    return <Navigate to="/" />;
  }
  return (
    <div className="Auth-form-container">
      <form onSubmit={handleSubmit(onSubmit)} className="Auth-form">
        <div className="Auth-form-content">
          <h3 className="Auth-form-title">Iniciar Sesión</h3>
          <div className="text-center">
            {" No estás registrado? "}
            <Link to={"/register"} className="link-primary">
              Registrate
            </Link>
          </div>
          <div className="form-group mt-3">
            <label>Usuario</label>
            <input
              name="email"
              type="email"
              className="form-control mt-1"
              placeholder="usuario@gmail.com"
              {...register("email", { required: "Ingresa un email valido" })}
              onChange={onChangeEmail}
            />
            {errors.email?.message && (
              <span className="danger">Ingresa un email valido</span>
            )}
          </div>
          <div className="form-group mt-3">
            <label>Contraseña</label>
            <input
              name="password"
              type="password"
              className="form-control mt-1"
              {...register("password", { required: "contraseña incorrecta" })}
              placeholder="Ingrese contraseña"
              onChange={onChangePassword}
            />
            {/* {errors?.password && (
              <span className="danger">{errors.password.message}</span>
            )} */}
          </div>  
          <div className="d-grid gap-2 mt-3">
            <button className="btn btn-success" disabled={loading}>Ingresar</button>
          </div>
          <p className="text-center mt-2">
            Olvidaste tu <Link to={"/recovery-password"} className="link-primary">
              contraseña?
            </Link>
          </p>
        </div>
      </form>
    </div>
  );
}


export default Login;